import axios from "axios";

class PageService {
  static getPageInfos = (pathname) =>
    axios.get("/getPageInfos", { params: { pathname } }).then((response) => response.data);

  static findPagesByTemplateKeys = (params) =>
    axios.get("/findPagesByTemplates", { params }).then((response) => response.data);

  static findHighlightNews = (params) => axios.get("/findHighlightNews", { params }).then((response) => response.data);

  static getTags = (params) => axios.get("/findTags", { params }).then((response) => response.data);

  static findPages = (params) => axios.get("/findPages", { params }).then((response) => response.data);

  static search = ({ query, lang, from, size }) =>
    axios.post("/search", { query, lang, from, size }).then((response) => response.data);
}

export default PageService;
